import React, { useRef, useEffect, useState } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBIcon,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";

import Table from "../Table";
import { useLocation, useNavigate } from "react-router-dom";
import DataTable from "../DataTable";
import voucherDateAndTimeFormatter from "../../utilities/voucherDateAndTimeFormatter";
import TotalRegisteredMembersDataTable from "./TotalRegisteredMembersDataTable";
import Loader from "../Loader";
import axios from "axios";
import API_BASE_URL from "../../utilities/apiConfig";
import axiosInstance from "../../utilities/apiConfig";

const Inactive = () => {
  const [loading, setLoading] = useState(false);
  const [inactiveMembersDetailsList, setInactiveMembersDetailsList] = useState(
    []
  );
  // const navigate = useNavigate();
  // const location = useLocation();
  // const { InactiveMembersData } = location.state;

  const handleGetInactiveMemberFromTwoMonths = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/Dashboard/get_inactive_members_from_last_two_month`
      );

      console.log("inactive request data", response.data);
      if (response.data.response.statusCode === 200) {
        setInactiveMembersDetailsList(response.data.inactiveMembers);
      } else {
        setInactiveMembersDetailsList([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatRegData = voucherDateAndTimeFormatter(
    inactiveMembersDetailsList,
    ["registrationDate"]
  );

  const handleClick = (event, cellValues) => {
    console.log("button executed", cellValues);
  };

  const newMembershipRequestTableColumns = [
    {
      field: "advocateBarId",
      headerName: "Registration No",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "registrationDate",
      headerName: "Registration Date",
      type: "text",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },

    {
      field: "name",
      headerName: "Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relationshipType",
      headerName: "Relationship Type",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "relativeName",
      headerName: "Relative Name",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "mobileNumber",
      headerName: "Mobile Number",
      minWidth: 150,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 180,
      flex: 1,
      align: "left",
      headerAlign: "left",
    },
    // { field: 'permanentAddress', headerName: 'Permanent Address', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'appliedDate', headerName: 'Applied Date', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // // { field: 'barAssociationId', headerName: 'Bar Association ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'dateOfBirth', headerName: 'Date of Birth', type: 'text', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'bloodGroup', headerName: 'Blood Group', minWidth: 120, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'isPreviousDepartment', headerName: 'Previous Department', type: 'boolean', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'previousDepartment', headerName: 'Previous Department', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'retirementYear', headerName: 'Retirement Year', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'mentorAdvocateBarId', headerName: 'Mentor Advocate Bar ID', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorAdvocateName', headerName: 'Mentor Advocate Name', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'mentorJoiningDate', headerName: 'Mentor Joining Date', type: 'text', minWidth: 180, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'chamberNumber', headerName: 'Chamber Number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'pendingRequestId', headerName: 'Pending Request ID', type: 'number', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' },

    // {
    //   field: "aadharDocument",
    //   headerName: 'Aadhar',

    //   renderCell: (cellValues) => {
    //     return (
    //       <MDBBtn
    //         variant="contained"
    //         color="primary"
    //         onClick={(event) => {
    //           handleClick(event, cellValues);
    //         }}
    //         size='sm'
    //         className='py-1'
    //       >
    //         View
    //       </MDBBtn>
    //     );
    //   }
    // },

    // { field: 'aadharDocument', headerName: 'Aadhar Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'affidavitDocument', headerName: 'Affidavit Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'highSchoolDocument', headerName: 'High School Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'intermediateDocument', headerName: 'Intermediate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'graduationDocument', headerName: 'Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'postGraduationDocument', headerName: 'Post Graduation Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },
    // { field: 'doctorateDocument', headerName: 'Doctorate Document', minWidth: 200, flex: 1, align: 'left', headerAlign: 'left' },

    // { field: 'status', headerName: 'Status', minWidth: 150, flex: 1, align: 'left', headerAlign: 'left' }
  ];

  useEffect(() => {
    handleGetInactiveMemberFromTwoMonths();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <MDBContainer fluid>
        {/* <MDBRow className="bg-primary text-white py-3">
        <MDBCol md="8" className="d-flex align-items-center">
          <img src={baricon} alt="Dashboard Icon" className="me-2" style={{ width: '48px' }} />
          <h4>Bar Association Dehradun</h4>
        </MDBCol>
        <MDBCol className="d-flex align-items-center justify-content-end">
          <img src={proficon} alt="Dashboard Icon" className="me-2" style={{ width: '48px' }} />
          <div>
            <h6 className="text-center">SUPER ADMIN</h6>
            <div outline color="light" size="sm" className="ms-2 text-center">
              Logout
            </div>
          </div>
        </MDBCol>
      </MDBRow> */}

        <TotalRegisteredMembersDataTable
          TableData={formatRegData}
          tableName="Inactive Bar Members"
          TableColumns={newMembershipRequestTableColumns}
          height={750}
        />
      </MDBContainer>
    </>
  );
};

export default Inactive;
